import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import { collection, onSnapshot, doc, deleteDoc, getDocs, updateDoc, Timestamp } from "firebase/firestore";
import db from "./Firebase";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { startOfDay, endOfDay, isWithinInterval, format } from "date-fns";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";

const PageVisitsScreen = () => {
    const [visits, setVisits] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchUserId, setSearchUserId] = useState("");
    const [searchPageName, setSearchPageName] = useState("");
    const [searchModule, setSearchModule] = useState("");
    const [searchDesc, setSearchDesc] = useState("");
    const [showCalendar, setShowCalendar] = useState(false);
    const [showSecondTable, setSecondTable] = useState(false);
    const [timeRange, setTimeRange] = useState("");
    const [userStats, setUserStats] = useState([]);
    const [personalDetails, setPersonalDetails] = useState({});
    const [location, setLocation] = useState({});
    const today = new Date();
    const [dateRange, setDateRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection"
        }
    ]);
    const userClickMap = {};

    const [categoryData, setCategoryData] = useState(null);


    const [moduleCategoryStats, setModuleCategoryStats] = useState(null);
    const [selectedModule, setSelectedModule] = useState("Learn"); // default selection


    const allowedLabels = ["Learn", "Grow", "Guidance", "Finance", "Membership", "Manage", "Community"];
    const categoryAliases = {
        "Learn Page": "Learn",
        "Grow Section": "Grow",
        "Finance Home": "Finance",
    };


    useEffect(() => {
        const fetchPersonalDetails = async () => {
            try {
                const snapshot = await getDocs(collection(db, "profile_type"));
                const userMap = {};

                snapshot.forEach((doc) => {
                    const data = doc.data();
                    userMap[data.phone_no] = {
                        name: data.name || "N/A",
                        profile_type: data.profile_type || "N/A",
                        age_range: data.age_range || "N/A",
                    };
                });

                setPersonalDetails(userMap);
            } catch (error) {
                console.error("Error fetching personal details:", error);
            }
        };

        fetchPersonalDetails();
    }, []);

    useEffect(() => {
        const fetchLocation = async () => {
            try {
                const snapshot = await getDocs(collection(db, "parlour_name"));
                const userMap = {};

                snapshot.forEach((doc) => {
                    const data = doc.data();
                    userMap[data.phone] = {
                        city: data.city || "N/A",
                        state: data.state || "N/A",
                    };
                });

                setLocation(userMap);
            } catch (error) {
                console.error("Error fetching personal details:", error);
            }
        };

        fetchLocation();
    }, []);





    useEffect(() => {
        if (selectedModule && visits.length > 0) {
            computeCategoryStatsForModule(selectedModule);
        }
    }, [selectedModule, visits]);


    const deleteInactiveUsersBeforeApril10 = async () => {
        const cutoffDate = new Date("2025-04-13T00:00:00Z");
        const usersRef = collection(db, "users_activity");

        try {
            const snapshot = await getDocs(usersRef);
            const deletePromises = [];

            snapshot.forEach((userDoc) => {
                const userData = userDoc.data();
                const visits = userData.page_visits;

                // Only delete if there's at least one visit before cutoff
                if (Array.isArray(visits)) {
                    const hasOldVisit = visits.some(visit => {
                        const visitTime = visit.visit_time?.toDate?.() || new Date(visit.visit_time);
                        return visitTime < cutoffDate;
                    });

                    if (hasOldVisit) {
                        console.log(`Deleting user with old visit: ${userDoc.id}`);
                        deletePromises.push(deleteDoc(doc(db, "users_activity", userDoc.id)));
                    }
                }
            });

            await Promise.all(deletePromises);
            console.log("Deletion complete ✅");
        } catch (error) {
            console.error("Error deleting documents:", error);
        }
    };


    const [mostVisited, setMostVisited] = useState(null);
    const [leastVisited, setLeastVisited] = useState(null);
    const [moduleFilter, setModuleFilter] = useState("");
    const [lastActiveMap, setLastActiveMap] = useState({});
    const [inactivityFilter, setInactivityFilter] = useState("");


    // useEffect(() => {
    //     const unsubscribe = onSnapshot(collection(db, "users_activity"), (snapshot) => {
    //         let allVisits = [];
    //         const categoryCount = {};

    //         snapshot.docs.forEach((userDoc) => {
    //             const userId = userDoc.id;
    //             const userData = userDoc.data();

    //             if (Array.isArray(userData.page_visits)) {
    //                 userData.page_visits.forEach((visit) => {
    //                     let visitTime = visit.visit_time;
    //                     if (visitTime?.toDate) {
    //                         visitTime = visitTime.toDate();
    //                     }

    //                     allVisits.push({
    //                         docid: userId,
    //                         page_name: visit.page_name,
    //                         visit_time: visitTime,
    //                         category: visit.category,
    //                         description: visit.description,
    //                     });

    //                     if (visit.page_name) {
    //                         categoryCount[visit.page_name] = (categoryCount[visit.page_name] || 0) + 1;
    //                     }
    //                 });
    //             }
    //         });

    //         allVisits.sort((a, b) => b.visit_time - a.visit_time);
    //         // setVisits(allVisits);
    //         const filteredByDate = allVisits.filter((visit) => {
    //             const visitDate = new Date(visit.visit_time);
    //             return isWithinInterval(visitDate, {
    //                 start: startOfDay(dateRange[0].startDate),
    //                 end: endOfDay(dateRange[0].endDate),
    //             });
    //         });

    //         setVisits(filteredByDate);

    //         const allowedLabels = ["Learn", "Grow", "Guidance", "Finance", "Membership", "Manage", "Community"];
    //         const categoryAliases = {
    //             "Learn Page": "Learn",
    //             "Grow Section": "Grow",
    //             "Finance Home": "Finance",
    //         };

    //         const filteredCategoryCount = Object.entries(categoryCount).reduce((acc, [key, value]) => {
    //             const normalizedKey = categoryAliases[key] || key;
    //             if (allowedLabels.some(label => normalizedKey.includes(label))) {
    //                 acc[normalizedKey] = (acc[normalizedKey] || 0) + value;
    //             }
    //             return acc;
    //         }, {});

    //         // Sort for highest/lowest
    //         const sorted = Object.entries(filteredCategoryCount).sort((a, b) => b[1] - a[1]);
    //         setMostVisited(sorted[0]);
    //         setLeastVisited(sorted[sorted.length - 1]);

    //         setCategoryData(
    //             sorted.length === 0
    //                 ? null
    //                 : {
    //                     labels: sorted.map(([key]) => key),
    //                     datasets: [{
    //                         label: 'Page Visits by Module',
    //                         data: sorted.map(([_, val]) => val),
    //                         backgroundColor: [
    //                             "#FF9800", "#3F51B5", "#009688", "#9C27B0",
    //                             "#4CAF50", "#F44336", "#00BCD4"
    //                         ]
    //                     }]
    //                 }
    //         );
    //     });

    //     return () => unsubscribe();
    // }, [dateRange]);


    useEffect(() => {
        setLoading(true);
        const unsubscribe = onSnapshot(collection(db, "users_activity"), (snapshot) => {
            let allVisits = [];
            const activeMap = {};

            snapshot.docs.forEach((userDoc) => {
                const userId = userDoc.id;
                const userData = userDoc.data();

                // capture last_active per user
                if (userData.last_active) {
                    const la = userData.last_active?.toDate ? userData.last_active.toDate() : new Date(userData.last_active);
                    if (!isNaN(la.getTime())) activeMap[userId] = la;
                }

                if (Array.isArray(userData.page_visits)) {
                    userData.page_visits.forEach((visit) => {
                        let visitTime = visit.visit_time;
                        if (visitTime?.toDate) {
                            visitTime = visitTime.toDate();
                        }

                        allVisits.push({
                            docid: userId,
                            page_name: visit.page_name,
                            visit_time: visitTime,
                            category: visit.category,
                            description: visit.description,
                        });
                    });
                }
            });

            setLastActiveMap(activeMap);
            setLoading(false);

            // Filter by selected date range FIRST
            const filteredByDate = allVisits.filter((visit) => {
                const visitDate = new Date(visit.visit_time);
                return isWithinInterval(visitDate, {
                    start: startOfDay(dateRange[0].startDate),
                    end: endOfDay(dateRange[0].endDate),
                });
            });
            filteredByDate.sort((a, b) => b.visit_time - a.visit_time);

            setVisits(filteredByDate); // ✅ all app logic now works with filtered data only

            // Compute category count from filtered visits only
            const categoryCount = {};
            const allowedLabels = ["Learn", "Grow", "Guidance", "Finance", "Membership", "Manage", "Community"];
            const categoryAliases = {
                "Learn Page": "Learn",
                "Grow Section": "Grow",
                "Finance Home": "Finance",
            };

            filteredByDate.forEach((visit) => {
                const raw = visit.page_name;
                const normalized = categoryAliases[raw] || raw;

                if (allowedLabels.some(label => normalized.includes(label))) {
                    categoryCount[normalized] = (categoryCount[normalized] || 0) + 1;
                }
            });

            // Compute user stats
            const userClickMap = {};

            const moduleAliases = {
                "My Funds Page": "Finance",
                "Learn Page": "Learn",
            };

            filteredByDate.forEach((visit) => {
                const userId = visit.docid;
                // const module = visit.page_name;

                const rawModule = visit.page_name;
                const module = moduleAliases[rawModule] || rawModule;


                if (!userClickMap[userId]) {
                    userClickMap[userId] = {
                        total: 0,
                        Learn: 0,
                        Grow: 0,
                        Guidance: 0,
                        Finance: 0,
                        Membership: 0,
                        Manage: 0,
                        Community: 0
                    };
                }

                userClickMap[userId].total += 1;

                // Track key modules
                // Track key modules
                if (["Learn", "Grow", "Guidance", "Finance", "Membership", "Manage", "Community"].includes(module)) {
                    if (!userClickMap[userId][module]) {
                        userClickMap[userId][module] = 0;
                    }
                    userClickMap[userId][module]++;
                }
            });

            // Convert to array and sort by total descending
            const userStatsArray = Object.entries(userClickMap)
                .map(([userId, stats]) => ({ userId, ...stats }))
                .sort((a, b) => b.total - a.total);

            setUserStats(userStatsArray);


            const sorted = Object.entries(categoryCount).sort((a, b) => b[1] - a[1]);
            setMostVisited(sorted[0]);
            setLeastVisited(sorted[sorted.length - 1]);

            setCategoryData(
                sorted.length === 0
                    ? null
                    : {
                        labels: sorted.map(([key]) => key),
                        datasets: [{
                            label: 'Page Visits by Module',
                            data: sorted.map(([_, val]) => val),
                            backgroundColor: [
                                "#FF9800", "#3F51B5", "#009688", "#9C27B0",
                                "#4CAF50", "#F44336", "#00BCD4"
                            ]
                        }]
                    }
            );
        });

        return () => unsubscribe();
    }, [dateRange]);



    useEffect(() => {
        const allowedLabels = ["Learn", "Grow", "Guidance", "Finance", "Membership", "Manage", "Community"];
        const categoryAliases = {
            "Learn Page": "Learn",
        };
        const categoryCount = {};

        visits.forEach((visit) => {
            if (!visit.visit_time) return;

            const visitDate = new Date(visit.visit_time);
            const hour = visitDate.getHours();

            const inDateRange = isWithinInterval(visitDate, {
                start: startOfDay(dateRange[0].startDate),
                end: endOfDay(dateRange[0].endDate),
            });

            const inTimeRange = () => {
                if (!timeRange) return true;
                const [start, end] = timeRange.split("-").map(Number);
                return hour >= start && hour < end;
            };

            if (inDateRange && inTimeRange()) {
                const rawCategory = visit.page_name;
                const normalizedCategory = categoryAliases[rawCategory] || rawCategory;

                if (allowedLabels.includes(normalizedCategory)) {
                    categoryCount[normalizedCategory] = (categoryCount[normalizedCategory] || 0) + 1;
                }
            }
        });

        setCategoryData(
            Object.keys(categoryCount).length === 0
                ? null
                : {
                    labels: Object.keys(categoryCount),
                    datasets: [
                        {
                            label: 'Page Visits by Module',
                            data: Object.values(categoryCount),
                            backgroundColor: [
                                "#FF9800", "#3F51B5", "#009688",
                                "#9C27B0", "#4CAF50", "#F44336", "#00BCD4"
                            ]
                        }
                    ]
                }
        );
    }, [visits, dateRange, timeRange, userStats]); // ✅ added `timeRange`





    const computeCategoryStatsForModule = (moduleName) => {
        const categoryCount = {};

        visits.forEach((visit) => {
            if ((visit.page_name === moduleName || categoryAliases[visit.page_name] === moduleName) && visit.category) {
                categoryCount[visit.category] = (categoryCount[visit.category] || 0) + 1;
            }
        });

        const sorted = Object.entries(categoryCount).sort((a, b) => b[1] - a[1]);
        if (sorted.length > 0) {
            setModuleCategoryStats({
                mostVisited: sorted[0],
                leastVisited: sorted[sorted.length - 1],
            });
        } else {
            setModuleCategoryStats(null);
        }
    };


    const formatTimestamp = (timestamp) => {
        if (!timestamp) return "N/A";
        const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
        return isNaN(date.getTime()) ? "Invalid Date" : date.toLocaleString();
    };

    const filteredVisits = visits.filter((visit) => {
        if (!visit.visit_time) return false;

        const visitDate = new Date(visit.visit_time); // Ensure it's a Date object
        const hour = visitDate.getHours();

        const isTimeInRange = () => {
            if (!timeRange) return true;
            const [start, end] = timeRange.split("-").map(Number);
            return hour >= start && hour < end;
        };


        const matchInactivity = () => {
            if (!inactivityFilter) return true;
            const la = lastActiveMap[visit.docid];
            if (!la) return false;
            const diffDays = Math.floor((new Date() - la) / 86400000);
            return diffDays >= parseInt(inactivityFilter);
        };

        return (
            visit.docid.toLowerCase().includes(searchUserId.toLowerCase()) &&
            visit.page_name.toLowerCase().includes(searchPageName.toLowerCase()) &&
            visit.description.toLowerCase().includes(searchModule.toLowerCase()) &&
            visit.category.toLowerCase().includes(searchDesc.toLowerCase()) &&
            isWithinInterval(visitDate, {
                start: startOfDay(dateRange[0].startDate),
                end: endOfDay(dateRange[0].endDate),
            }) && isTimeInRange() && matchInactivity()
        );
    });

    const handleExport = () => {
        const sheetData = filteredVisits.map((visit, i) => ({
            "#": i + 1,
            "User ID": visit.docid,
            "Name": personalDetails[visit.docid]?.name || "N/A",
            "City": location[visit.docid]?.city || "N/A",
            "State": location[visit.docid]?.state || "N/A",
            "Profile Type": personalDetails[visit.docid]?.profile_type || "N/A",
            "Age Range": personalDetails[visit.docid]?.age_range || "N/A",
            "Module": visit.page_name === "My Funds Page" ? "Finance" : visit.page_name === "Learn Page" ? "Learn" : visit.page_name,
            "Category": visit.description,
            "Page": visit.category,
            "Visit Time": formatTimestamp(visit.visit_time),
        }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(sheetData), "Page Visits");
        XLSX.writeFile(wb, `page_visits_${format(dateRange[0].startDate, "yyyy-MM-dd")}_to_${format(dateRange[0].endDate, "yyyy-MM-dd")}.xlsx`);
    };

    return (
        <>
            <div className="p-2 flex justify-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>
            <div className="card-header pb-0 px-3 d-flex justify-content-end">

                <Link to="/dashbaordall" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-success btn-sm mr-3">
                        Log Dashboard
                    </button>
                </Link>
                <Link to="/analytics_details" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-success btn-sm">
                        User Analytics (Real-Time)
                    </button>
                </Link>
                <Link to="/inactive_visits" target="_blank" rel="noopener noreferrer" className="ms-2">
                    <button className="btn btn-success btn-sm">
                        Inactive Users
                    </button>
                </Link>

            </div>



            <div className="flex flex-col md:flex-row gap-4 mt-4">
                {/* Left Side - Chart */}
                <div className="bg-white p-3 shadow-md rounded-md w-full md:w-1/2">
                    <h3 className="text-base font-semibold mb-1 text-gray-700">Module Wise Data</h3>
                    {categoryData ? (
                        <Bar data={categoryData} />
                    ) : (
                        <p className="text-sm text-gray-500">Loading...</p>
                    )}
                </div>

                {/* Right Side - Placeholder (Add what you want here) */}
                <div className="bg-white p-3 shadow-md rounded-md w-full md:w-1/2">
                    <h3 className="text-base font-semibold mb-1 text-gray-700">Other Info:-</h3>


                    {/* <div className="flex flex-wrap gap-4 pt-4"> */}
                    <div className="flex gap-4">
                        {mostVisited && (!moduleFilter || mostVisited[0] === moduleFilter) && (
                            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded w-full md:w-1/2">
                                <strong>Most Visited Module:</strong>
                                <div>{mostVisited[0]} ({mostVisited[1]} visits)</div>
                            </div>
                        )}

                        {leastVisited && (!moduleFilter || leastVisited[0] === moduleFilter) && (
                            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded w-full md:w-1/2">
                                <strong>Least Visited Module:</strong>
                                <div>{leastVisited[0]} ({leastVisited[1]} visits)</div>
                            </div>
                        )}
                    </div>


                    <hr style={{ marginTop: "4rem", height: "0rem", backgroundColor: "black" }} />

                    {/* Module Filter Dropdown */}
                    <div className="my-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Select Module</label>
                        <select
                            value={selectedModule}
                            onChange={(e) => setSelectedModule(e.target.value)}
                            className="border p-2 rounded-md w-64"
                        >
                            {["Learn", "Grow", "Guidance", "Finance", "Membership", "Manage", "Community"].map((mod) => (
                                <option key={mod} value={mod}>{mod}</option>
                            ))}
                        </select>
                    </div>

                    {/* Most & Least Visited Categories */}
                    {moduleCategoryStats ? (
                        <div className="flex gap-4">
                            <div className="bg-green-100 border border-green-300 p-4 rounded-md w-1/2">
                                <h4 className="text-lg font-bold text-green-800">
                                    Most Visited Category in {selectedModule}
                                </h4>
                                <p className="mt-2 text-green-700">
                                    {moduleCategoryStats.mostVisited[0]} ({moduleCategoryStats.mostVisited[1]} visits)
                                </p>
                            </div>
                            <div className="bg-red-100 border border-red-300 p-4 rounded-md w-1/2">
                                <h4 className="text-lg font-bold text-red-800">
                                    Least Visited Category in {selectedModule}
                                </h4>
                                <p className="mt-2 text-red-700">
                                    {moduleCategoryStats.leastVisited[0]} ({moduleCategoryStats.leastVisited[1]} visits)
                                </p>
                            </div>
                        </div>

                    ) : (
                        <p className="text-sm text-gray-500 mt-4">No category data found for selected module.</p>
                    )}

                </div>
            </div>




            {/* <button
                className="border p-2 rounded-md bg-gray-100"
                onClick={() => deleteInactiveUsersBeforeApril10()}
                style={{ marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", width: "200px", marginLeft: "10px" }}
            >
                "Delete Data"
            </button> */}


            <div className="p-4">
                {/* <h2 className="text-xl font-bold mb-4">User Page Visits Logs</h2> */}

                {/* Search Filters */}
                {/* <div className="flex space-x-4 mb-4"> */}
                <div className="">
                    <input
                        type="text"
                        placeholder="Search by User ID..."
                        value={searchUserId}
                        onChange={(e) => setSearchUserId(e.target.value)}
                        className="border p-2 rounded-md w-1/3"
                        style={{ marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", width: "200px", marginLeft: "10px" }}
                    />
                    <input
                        type="text"
                        placeholder="Search by Module..."
                        value={searchPageName}
                        onChange={(e) => setSearchPageName(e.target.value)}
                        className="border p-2 rounded-md w-1/3"
                        style={{ marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", width: "200px", marginLeft: "10px" }}
                    />
                    <input
                        type="text"
                        placeholder="Search by Category..."
                        value={searchModule}
                        onChange={(e) => setSearchModule(e.target.value)}
                        className="border p-2 rounded-md w-1/3"
                        style={{ marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", width: "200px", marginLeft: "10px" }}
                    />

                    <input
                        type="text"
                        placeholder="Search by Page..."
                        value={searchDesc}
                        onChange={(e) => setSearchDesc(e.target.value)}
                        className="border p-2 rounded-md w-1/3"
                        style={{ marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", width: "200px", marginLeft: "10px" }}
                    />


                    <div style={{ position: "relative", display: "inline-block", marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", marginLeft: "10px" }}>
                        <button
                            className="border p-2 rounded-md bg-gray-100"
                            onClick={() => setShowCalendar(!showCalendar)}
                            style={{ width: "235px", backgroundColor: "#dee2e6", color: "black" }}
                        >
                            📅 {format(dateRange[0].startDate, "MM/dd/yyyy")} - {format(dateRange[0].endDate, "MM/dd/yyyy")}
                        </button>
                        {showCalendar && (
                            <div style={{ position: "absolute", top: "110%", left: 0, zIndex: 9999, background: "#fff", boxShadow: "0 4px 20px rgba(0,0,0,0.2)", borderRadius: "8px", padding: "12px" }}>
                                <DateRangePicker
                                    ranges={dateRange}
                                    onChange={(ranges) => setDateRange([ranges.selection])}
                                    maxDate={new Date()}
                                />
                                <button className="mt-2 text-red-500 ml-3" onClick={() => setShowCalendar(false)}>✖ Close</button>
                            </div>
                        )}
                    </div>

                    <select
                        value={timeRange}
                        onChange={(e) => setTimeRange(e.target.value)}
                        className="border p-2 rounded-md w-1/3"
                        style={{ marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", width: "200px", marginLeft: "10px" }}
                    >
                        <option value="">All Times</option>
                        <option value="0-6">12AM - 6AM</option>
                        <option value="6-12">6AM - 12PM</option>
                        <option value="12-18">12PM - 6PM</option>
                        <option value="18-24">6PM - 12AM</option>
                    </select>

                    <select
                        value={inactivityFilter}
                        onChange={(e) => setInactivityFilter(e.target.value)}
                        className="border p-2 rounded-md"
                        style={{ marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", width: "220px", marginLeft: "10px" }}
                    >
                        <option value="">All Users (by activity)</option>
                        <option value="30">Inactive 1+ month</option>
                        <option value="60">Inactive 2+ months</option>
                        <option value="90">Inactive 3+ months</option>
                        <option value="180">Inactive 6+ months</option>
                    </select>

                    {showSecondTable ? <><button
                        className="border p-2 rounded-md"
                        onClick={() => setSecondTable(false)}
                        style={{ marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", width: "200px", marginLeft: "10px", backgroundColor: "cadetblue", color: "white" }}
                    >
                        Show Log Report
                    </button></> : <> <button
                        className="border p-2 rounded-md"
                        onClick={() => setSecondTable(true)}
                        style={{ marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", width: "200px", marginLeft: "10px", backgroundColor: "cadetblue", color: "white" }}
                    >
                        View Most Active Users
                    </button></>}

                    <button
                        className="border p-2 rounded-md"
                        onClick={handleExport}
                        disabled={filteredVisits.length === 0}
                        style={{ marginRight: "10px", marginTop: "1rem", marginBottom: "1rem", width: "160px", marginLeft: "10px", backgroundColor: "#198754", color: "white", fontWeight: 700 }}
                    >
                        Export Excel
                    </button>

                </div>


                {/* Visits Table */}
                {showSecondTable ? (<>
                    <div className="mt-1">
                        <h2 className="text-lg font-bold mb-4">Most Active Users</h2>
                        <div className="overflow-x-auto">
                            <table className="min-w-full border border-gray-300 text-sm">
                                <thead className="bg-gray-200">
                                    <tr>
                                        <th className="border p-2 text-left">#</th>
                                        <th className="border p-2 text-left">User ID</th>

                                        <th className="border p-2 text-left">Total Clicks</th>
                                        <th className="border p-2 text-left">Learn Clicks</th>
                                        <th className="border p-2 text-left">Manage Clicks</th>
                                        <th className="border p-2 text-left">Grow Clicks</th>
                                        <th className="border p-2 text-left">Community</th>
                                        <th className="border p-2 text-left">Finance</th>
                                        <th className="border p-2 text-left">Guidance Session</th>
                                        <th className="border p-2 text-left">Membership</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userStats.map((user, index) => (
                                        <tr key={user.userId} className="hover:bg-gray-50">
                                            <td className="border p-2">{index + 1}</td>
                                            <td className="border p-2">{user.userId}</td>
                                            <td className="border p-2">{user.total}</td>
                                            <td className="border p-2">{user.Learn}</td>
                                            <td className="border p-2">{user.Manage}</td>
                                            <td className="border p-2">{user.Grow}</td>
                                            <td className="border p-2">{user.Community}</td>
                                            <td className="border p-2">{user.Finance}</td>
                                            <td className="border p-2">{user.Guidance}</td>
                                            <td className="border p-2">{user.Membership}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>) : (<>
                    <div className="overflow-x-auto">
                        <h2 className="text-lg font-bold mb-4">User Page Visits Logs</h2>
                        <table className="min-w-full border border-gray-300">
                            <thead className="bg-gray-200">
                                <tr>
                                    <th className="border p-2 text-left">#</th>
                                    <th className="border p-2 text-left">User ID</th>
                                    <th className="border p-2 text-left">Name</th>
                                    <th className="border p-2 text-left">City</th>
                                    <th className="border p-2 text-left">State</th>
                                    <th className="border p-2 text-left">ProfileType</th>
                                    <th className="border p-2 text-left">Age Range</th>
                                    <th className="border p-2 text-left">Module</th>
                                    <th className="border p-2 text-left">Category</th>
                                    <th className="border p-2 text-left">Page</th>
                                    <th className="border p-2 text-left">Visit Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredVisits.length > 0 ? (
                                    filteredVisits.map((visit, index) => (
                                        <tr key={index} className="hover:bg-gray-100">
                                            <td className="border p-2">{index + 1}</td>
                                            <td className="border p-2">{visit.docid}</td>
                                            <td className="border p-2">
                                                {personalDetails[visit.docid]?.name || "N/A"}
                                            </td>
                                            <td className="border p-2">
                                                {location[visit.docid]?.city || "N/A"}
                                            </td>
                                            <td className="border p-2">
                                                {location[visit.docid]?.state || "N/A"}
                                            </td>
                                            <td className="border p-2">
                                                {personalDetails[visit.docid]?.profile_type || "N/A"}
                                            </td>
                                            <td className="border p-2">
                                                {personalDetails[visit.docid]?.age_range || "N/A"}
                                            </td>
                                            <td className="border p-2">{visit.page_name == "My Funds Page" ? "Finance" : visit.page_name == "Learn Page" ? "Learn" : visit.page_name}</td>
                                            <td className="border p-2 ">{visit.description}</td>
                                            <td className="border p-2 whitespace-normal break-words max-w-xs">{visit.category == "001" ? "Content Creation: Basic Principles" : visit.category == "005" ? "Professional Nail Art & Extensions" : visit.category == "006" ? "Hair Color Basics: Trends & Techniques" : visit.category == "007" ? "WhatsApp Business for Small Business Owners" : visit.category}</td>
                                            <td className="border p-2">{formatTimestamp(visit.visit_time)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="12" className="text-center p-4">
                                            {loading ? (
                                                <>
                                                    <div className="spinner-border spinner-border-sm text-primary me-2" role="status" />
                                                    <span className="text-muted">Loading data…</span>
                                                </>
                                            ) : (
                                                <span className="text-gray-500">No matching records found</span>
                                            )}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div></>)}

            </div>
        </>
    );
};

export default PageVisitsScreen;

// import React, { useState, useEffect } from "react";


// import { collection, onSnapshot } from "firebase/firestore";
// import db from "./Firebase";

// const PageVisitsScreen = () => {
//     const [visits, setVisits] = useState([]);
//     const [searchUserId, setSearchUserId] = useState("");
//     const [searchPageName, setSearchPageName] = useState("");

//     useEffect(() => {
//         const unsubscribe = onSnapshot(collection(db, "users_activity"), (snapshot) => {
//             let allVisits = [];

//             snapshot.docs.forEach((userDoc) => {
//                 const userId = userDoc.id;
//                 const userData = userDoc.data();

//                 if (Array.isArray(userData.page_visits)) {
//                     userData.page_visits.forEach((visit) => {
//                         let visitTime = visit.visit_time;

//                         // Convert Firestore Timestamp to Date
//                         if (visitTime?.toDate) {
//                             visitTime = visitTime.toDate();
//                         }

//                         allVisits.push({
//                             docid: userId,
//                             page_name: visit.page_name,
//                             visit_time: visitTime,
//                             category: visit.category,
//                             description: visit.description,
//                         });
//                     });
//                 }
//             });

//             // Sort by latest visit time first
//             allVisits.sort((a, b) => b.visit_time - a.visit_time);
//             setVisits(allVisits);
//         });

//         return () => unsubscribe();
//     }, []);

//     const formatTimestamp = (timestamp) => {
//         if (!timestamp) return "N/A";
//         const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
//         return isNaN(date.getTime()) ? "Invalid Date" : date.toLocaleString();
//     };

//     // Filter visits based on search inputs
//     const filteredVisits = visits.filter((visit) =>
//         visit.docid.toLowerCase().includes(searchUserId.toLowerCase()) &&
//         visit.page_name.toLowerCase().includes(searchPageName.toLowerCase())
//     );

//     return (
//         <div className="p-4">
//             <h2 className="text-xl font-bold mb-4">User Page Visits Logs</h2>

//             {/* Search Filters */}
//             <div className="flex space-x-4 mb-4">
//                 <input
//                     type="text"
//                     placeholder="Search by User ID..."
//                     value={searchUserId}
//                     onChange={(e) => setSearchUserId(e.target.value)}
//                     className="border p-2 rounded-md w-1/3"
//                 />
//                 <input
//                     type="text"
//                     placeholder="Search by Page Name..."
//                     value={searchPageName}
//                     onChange={(e) => setSearchPageName(e.target.value)}
//                     className="border p-2 rounded-md w-1/3"
//                 />
//             </div>

//             {/* Visits Table */}
//             <div className="overflow-x-auto">
//                 <table className="min-w-full border border-gray-300">
//                     <thead className="bg-gray-200">
//                         <tr>
//                             <th className="border p-2 text-left">User ID</th>
//                             <th className="border p-2 text-left">Page Name</th>
//                             <th className="border p-2 text-left">Category</th>
//                             <th className="border p-2 text-left">Description</th>
//                             <th className="border p-2 text-left">Visit Time</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredVisits.length > 0 ? (
//                             filteredVisits.map((visit, index) => (
//                                 <tr key={index} className="hover:bg-gray-100">
//                                     <td className="border p-2">{visit.docid}</td>
//                                     <td className="border p-2">{visit.page_name}</td>
//                                     <td className="border p-2">{visit.category}</td>
//                                     <td className="border p-2">{visit.description}</td>
//                                     <td className="border p-2">{formatTimestamp(visit.visit_time)}</td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="5" className="text-center text-gray-500 p-4">
//                                     No matching records found
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default PageVisitsScreen;

// // import React, { useState, useEffect } from "react";


// // import { collection, onSnapshot } from "firebase/firestore";
// // import db from "./Firebase";

// // const PageVisitsScreen = () => {
// //     const [visits, setVisits] = useState([]);

// //     useEffect(() => {
// //         const unsubscribe = onSnapshot(collection(db, "users_activity"), (snapshot) => {
// //             let allVisits = [];

// //             snapshot.docs.forEach((userDoc) => {
// //                 const userId = userDoc.id;
// //                 const userData = userDoc.data();

// //                 if (Array.isArray(userData.page_visits)) {
// //                     userData.page_visits.forEach((visit) => {
// //                         let visitTime = visit.visit_time;

// //                         // If visit_time is Firestore Timestamp, convert using toDate()
// //                         if (visitTime && visitTime.toDate) {
// //                             visitTime = visitTime.toDate();
// //                         }

// //                         allVisits.push({
// //                             docid: userId,
// //                             page_name: visit.page_name,
// //                             visit_time: visitTime,
// //                             category: visit.category,
// //                             description: visit.description,
// //                         });
// //                     });
// //                 }
// //             });

// //             // Sort visits by visit_time in descending order
// //             allVisits.sort((a, b) => b.visit_time - a.visit_time);
// //             setVisits(allVisits);
// //         });

// //         return () => unsubscribe();
// //     }, []);

// //     const formatTimestamp = (timestamp) => {
// //         if (!timestamp) return "N/A";

// //         let date = timestamp instanceof Date ? timestamp : new Date(timestamp);

// //         return isNaN(date.getTime()) ? "Invalid Date" : date.toLocaleString();
// //     };

// //     return (
// //         <div className="p-2">
// //             <h2 className="text-xl font-bold mb-4">User Page Visits</h2>
// //             <div className="overflow-x-auto">
// //                 <table className="min-w-full border border-gray-300">
// //                     <thead className="bg-gray-200">
// //                         <tr>
// //                             <th className="border p-2 text-left">User</th>
// //                             <th className="border p-2 text-left font-semibold">Module</th>
// //                             <th className="border p-2 text-left font-semibold">Category</th>
// //                             <th className="border p-2 text-left font-semibold">Description</th>
// //                             <th className="border p-2 text-left font-semibold">Visit Time</th>
// //                         </tr>
// //                     </thead>
// //                     <tbody>
// //                         {visits.map((visit, index) => (
// //                             <tr key={index} className="hover:bg-gray-100">
// //                                 <td className="border p-2">{visit.docid}</td>
// //                                 <td className="border p-2">{visit.page_name}</td>
// //                                 <td className="border p-2">{visit.category}</td>
// //                                 <td className="border p-2">{visit.description}</td>
// //                                 <td className="border p-2">{formatTimestamp(visit.visit_time)}</td>
// //                             </tr>
// //                         ))}
// //                     </tbody>
// //                 </table>
// //             </div>
// //         </div>
// //     );
// // };

// // export default PageVisitsScreen;